<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div class="p-24 bg-zinc-50 rounded">
        <form [formGroup]="formGroup">
            <div fxLayout="row wrap" fxLayoutGap="16px">
                <div fxFlex="1 0 calc(50% - 16px)" *ngFor="let managerPermission of moduleManagerPermissions.all; let i = index">
                    <mat-checkbox [formControl]="permissionsFormArray.at(i)" [class.mb-16]="managerPermission.description">
                        <div fxLayout="column" class="ml-8">
                            <h3 class="text-sm font-semibold my-0">{{ managerPermission.title | translate }}</h3>
                            <p class="text-sm font-light mt-4 mb-0" *ngIf="managerPermission.description">{{ managerPermission.description | translate }}</p>
                        </div>
                    </mat-checkbox>
                </div>
            </div>
        </form>
    </div>
</div>

<div mat-dialog-actions class="pt-0 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="saveSelected()"></app-flat-button>
</div>
